<template>
  <div>
    <el-descriptions border size="small" :column="1" class="mt-1 bl-s-1 br-s-1">
      <el-descriptions-item
        :label="$l('form_label_fabricScmName') || '店铺名称'"
        :labelStyle="{ width: '100px' }"
      >
        {{ formData.resFabricScmName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_fabricScmAddress') || '店铺地址'"
        :labelStyle="{ width: '100px' }"
      >
        {{ formData.resFabricScmAddress || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-card class="mt-3" :body-style="{ padding: '0 0 0 0' }" shadow="never">
      <div style="display: flex;justify-content: space-between;">
        <div style="width:146px">
          <div style="width:130px; height:130px" class="mr-2 ml-2">
            <el-image
              :src="
                formData.thumbImageUrl
                  ? $osscdn(formData.thumbImageUrl)
                  : '/image/static/img/nopic.jpg'
              "
              :preview-src-list="imgUriList"
              style="width:130px; height:130px"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 130px; height: 130px"
                />
              </div>
            </el-image>
          </div>
        </div>
        <div style="width:703px" class="bl-s-1">
          <el-descriptions
            border
            size="small"
            :column="2"
            :labelStyle="{ width: '85px', fontSize: '14px' }"
            :contentStyle="{
              width: '266px',
              fontSize: '14px',
            }"
          >
            <el-descriptions-item
              :label="$l('form_label_fty_no') || '厂家编号'"
            >
              {{ formData.ftyNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_no') || '面料编号'"
            >
              {{ formData.fabricNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_name') || '面料名称'"
            >
              <dict-select
                v-model="formData.fabricDescriptionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Fabric Description' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
                disabled
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('form_label_pattern') || '花型'">
              <dict-select
                v-model="formData.patternArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Pattern' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                disabled
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('table_label_techName') || '工艺'">
              <dict-select
                v-model="formData.techniqueArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Technique' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                disabled
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('INDEX.choose_fabric_function') || '功能'"
            >
              <dict-select
                v-model="formData.functionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Function' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                disabled
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_weight') || '克重'"
            >
              <div>
                <span> {{ formData.fabricWeight || '' }}</span>
                <span> {{ formData.v_fabricWeightUnit || '' }}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_wid') || '门幅'"
            >
              <div>
                <span> {{ formData.fabricWid || '' }}</span>
                <span> {{ formData.v_widUnit || '' }}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :label="$l('form_label_moq') || '起定量'">
              {{ formData.moq || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_unitPrice') || '面料单价'"
            >
              <div>
                <span> {{ formData.unitPrice || '' }}</span>
                <span> {{ formData.v_fabricUnit || '' }}</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabric_content') || '成分'"
            >
            {{ formData.fabricContent || '' }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </el-card>

    <FabricInfoColor
      ref="FabricInfoColor"
      :resFabricInfoCode="resFabricInfoCode"
      :resFabricScmCode="resFabricScmCode"
      @save="save"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import FabricInfoColor from '../fabric-info-image'

export default {
  mixins: [EditLoading],
  components: {
    FabricInfoColor,
  },
  props: {
    resFabricInfoCode: { type: String, default: '' },
    resFabricScmCode: { type: String, default: '' },
  },
  computed: {
    imgUriList() {
      return [this.formData.imageUrl]
    },
  },
  data() {
    return {
      backDialogVisible: false,
      loading: false,
      formData: {
        resFabricInfoCode: '',
        resFabricScmCode: '',
        resFabricRecordCode: '',
        fabricCode: '',
        fabricName: '',
        fabricNameEn: '',
        fabricAttributes: '',
        ftyNo: '',
        fabricContent: '',
        fabricContentEn: '',
        fabricWid: '',
        widUnit: '',
        fabricWeight: '',
        fabricWeightUnit: '',
        unitPrice: '',
        fabricUnit: '',
        imageCode: '',
        imageUrl: '',
        thumbImageCode: '',
        thumbImageUrl: '',
      },
      imageVisible: true,
      fabricContentVisible: false,
      rules: {},
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.resFabricInfoCode) return
      this.loading = true
      const res = await this.$api
        .resFabricInfoDetailApi({
          resFabricInfoCode: this.resFabricInfoCode,
        })
        .catch(() => {})
      this.loading = false
      this.formData = res.body || {}
    },
    async save(detailList) {
      const tmpdata = []
      for (let i = 0; i < detailList.length; i++) {
        const { demandQty } = detailList[i]
        if (demandQty > 0) {
          tmpdata.push({ ...detailList[i] })
        }
      }
      if (tmpdata.length < 1) {
        this.$message({
          showClose: true,
          message: '请填写需求数量',
          type: 'warning',
        })
        return
      }
      const params = {
        detailList: tmpdata,
      }
      this.loadingOpen()
      const res = await this.$api
        .resFabricDemandDetailSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}

.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.bl-s-1 {
  border-left: 1px solid #ebeef5;
}
.br-s-1 {
  border-right: 1px solid #ebeef5;
}
</style>
